import { useChecklistSyncStatus } from 'src/queries/checklist/useChecklistSync';
import {
  ChecklistSyncJob,
  syncCompletedAt,
} from 'src/services/checklist/syncTypes';

interface ChecklistSyncStatusProps {
  readonly checklistId: string;
  readonly isGlobal: boolean;
}

const describe = (job: ChecklistSyncJob): string => {
  switch (job.status) {
    case 'PENDING':
      return 'Sync queued…';
    case 'RUNNING':
      return `Syncing ${job.loansProcessed} of ${job.loansTotal} loans…`;
    case 'FAILED':
      return `Last sync failed${job.lastError ? `: ${job.lastError}` : ''}`;
    default:
      return `Last synced ${syncCompletedAt(job)}`;
  }
};

/** One-line summary of the most recent sync of this checklist to its loans. */
export const ChecklistSyncStatus = ({
  checklistId,
  isGlobal,
}: ChecklistSyncStatusProps) => {
  const { data: job } = useChecklistSyncStatus(checklistId, isGlobal);

  if (!isGlobal || !job) return null;

  return (
    <div className="border-t border-gray-200 bg-gray-50 px-4 py-2 flex items-center justify-between">
      <p
        data-testid="checklist-sync-status"
        className={
          job.status === 'FAILED'
            ? 'text-xs text-red-600'
            : 'text-xs text-gray-500'
        }
      >
        {describe(job)}
      </p>
    </div>
  );
};

export default ChecklistSyncStatus;
